const MODAL_ID = "whatsapp-modal"
const CONTINUE_BUTTON_ID = "whatsapp-modal-continue"
const WHATSAPP_LINK_SELECTOR = ".send-whatsapp-link"

/**
 * The WhatsApp button the visitor clicked. It is kept until the visitor confirms the popup,
 * because the popup itself does not know which of the buttons on the page opened it.
 */
let pendingLink: HTMLAnchorElement | null = null

const modalElement = (): HTMLDivElement | null => document.getElementById(MODAL_ID) as HTMLDivElement | null

/**
 * Runs in the capture phase on the document, so it runs before the reveal listener that
 * crawler-protection/phone-number.ts puts on the same links. On the link itself the two would
 * run in registration order, which is not something this module can rely on.
 */
const interceptWhatsAppClick = (event: MouseEvent): void => {
    const eventTarget = event.target
    const clickedLink =
        eventTarget instanceof Element ? eventTarget.closest<HTMLAnchorElement>(WHATSAPP_LINK_SELECTOR) : null

    if (clickedLink === null) {
        return
    }

    // The visitor has confirmed this click already: let it through to the reveal listener.
    if (clickedLink.dataset.whatsappConfirmed === "true") {
        clickedLink.removeAttribute("data-whatsapp-confirmed")

        return
    }

    // An advert that has not been regenerated yet carries no popup: keep the direct link.
    if (modalElement() === null) {
        return
    }

    event.preventDefault()
    event.stopPropagation()

    pendingLink = clickedLink

    $(`#${MODAL_ID}`).modal("show")
}

const continueToWhatsApp = (): void => {
    const confirmedLink = pendingLink
    pendingLink = null

    $(`#${MODAL_ID}`).modal("hide")

    if (confirmedLink === null) {
        return
    }

    confirmedLink.dataset.whatsappConfirmed = "true"
    confirmedLink.click()
}

/**
 * Asks the visitor to name day, time, duration and wishes before WhatsApp opens.
 */
export const initWhatsAppPopup = (): void => {
    if (modalElement() === null) {
        return
    }

    document.addEventListener("click", interceptWhatsAppClick, true)
    document.getElementById(CONTINUE_BUTTON_ID)?.addEventListener("click", continueToWhatsApp)
}
